export const statusOptionsData = ["To-Do", "Pending", "In-Progress", "Done"];

export const priorityOptionsData = ["High", "Medium", "Low"];

export const randomDescriptionsData = [
    "Complete the project proposal.",
    "Research market competitors.",
    "Prepare the presentation slides.",
    "Write the technical documentation.",
    "Submit the project report.",
];
